import styled from 'styled-components/macro';
import { colorBlackTransparent50, colorCoreGray1000Base } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel2 } from '@yme/tokens/typography';
export const HeaderStyled = styled(HeadingLevel2) `
  margin-bottom: 34px;
`;
export const FilterLineStyled = styled(FlexWrapper) `
  margin-bottom: 32px;
`;
export const NoResultsPageStyled = styled(FlexWrapper) `
  flex-basis: 100%;
`;
export const NoResultIconStyled = styled(FlexWrapper) `
  width: 40px;
  height: 40px;
  background-color: ${colorCoreGray1000Base};
  border-radius: ${CORNER_RADIUS.circle};
`;
export const NoResultIconWrapperStyled = styled(FlexWrapper) `
  width: 64px;
  height: 64px;
  margin-bottom: 8px;
  border-radius: ${CORNER_RADIUS.circle};
  background-color: ${colorBlackTransparent50};
`;
